
const userData = JSON.parse(localStorage.getItem("userData"));
const role = userData?.[0]?.role; // Safely access user role

const menu = [
  {
    icon: "dashboard",
    text: "Dashboard",
    link: "/",
  },
  // {
  //   icon: "list-thumb-fill",
  //   text: "Policy",
  //   link: "/list-policy",
  // },
  // {
  //   icon: "list-thumb-fill",
  //   text: "Category",
  //   link: "/list-category",
  // },
  // {
  //   icon: "user-list",
  //   text: "Proposers",
  //   link: "/proposers",
  // },
  // {
  //   icon: "user-list",
  //   text: "Agent",
  //   link: "/client",
  // },
  // {
  //   icon: "file-docs",
  //   text: "CRM",
  //   link: "/main-sheet-list",
  // },
  {
    icon: "users-fill",
    text: "Team",
    link: "/team-list",
  },
  // {
  //   icon: "file-docs",
  //   text: "Comparison",
  //   link: "/comparisonlist",
  // },
];

const menuteam = [
  {
    icon: "dashboard",
    text: "Dashboard",
    link: "/",
  },
  // {
  //   icon: "list-thumb-fill",
  //   text: "Policy",
  //   link: "/list-policy",
  // },
  // {
  //   icon: "list-thumb-fill",
  //   text: "Category",
  //   link: "/list-category",
  // },
  // {
  //   icon: "user-list",
  //   text: "Proposers",
  //   link: "/proposers",
  // },
  // {
  //   icon: "user-list",
  //   text: "Agent",
  //   link: "/client",
  // },
  // {
  //   icon: "file-docs",
  //   text: "CRM",
  //   link: "/main-sheet-list",
  // },
  // {
  //   icon: "file-docs",
  //   text: "Comparison",
  //   link: "/comparisonlist",
  // },
];

let ComponentToExport;

if (role === 1) {
  ComponentToExport = menu;
} else {
  ComponentToExport = menuteam;
}

export default ComponentToExport;


